var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"cuxla"},React.createElement("path",{"fill":"#fff","d":"M0 1h26v18H0z"}))),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"none","stroke":"#fff","strokeMiterlimit":"50","strokeWidth":"3","d":"M0 1v0h26v18H0v0z","clipPath":"url(\"#cuxla\")"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","stroke":"#fff","strokeMiterlimit":"50","strokeWidth":"1.5","d":"M1 1v0l12 9v0l12-9v0"}))]))]);
}

EmailIcon.defaultProps = {"width":"26","height":"19","viewBox":"0 0 26 19"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
